export default __webpack_public_path__ + "static/media/Interactions.3f9773ab.svg";